import React, { useState, useEffect, useContext } from 'react';
import './OrgRejectionPanel.css';
import convenienceApi from '../../common/api/convenience';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import logComponent from '../../common/logComponent';

export default function OrgRejectionPanel({ organization, dismiss, dismissParent }) {
  const environmentContext = useContext(EnvironmentContext);
  const [rejectionStart, setRejectionStart] = useState(null);
  const [currentDisplay, setCurrentDisplay] = useState('initial');
  const [dismissalTimeout, setDismissalTimeout] = useState(null);
  const [resolutionTimeout, setResolutionTimeout] = useState(null);
  const [rejectionReason, setRejectionReason] = useState('');
  const { hasToken } = environmentContext;

  if (logComponent('OrgRejectionPanel')) { console.debug('OrgRejectionPanel rendered'); }

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (logComponent('OrgRejectionPanel')) { console.debug('OrgRejectionPanel onMount'); }

    return () => {
      if (dismissalTimeout) clearTimeout(dismissalTimeout);
      if (resolutionTimeout) clearTimeout(resolutionTimeout);
    };
  }, []);


  const confirmRejection = () => {
    if (logComponent('OrgRejectionPanel')) { console.debug('OrgRejectionPanel confirmRejection'); }

    if (!hasToken) return;

    showPendingMessage();

    convenienceApi.rejectStagedOrganization(organization, rejectionReason)
      .then(
        result => {
          organization.status = "rejected";
          handleResolution('success')
        },
        error => {
          handleResolution('failure');
        }
      );
  }

  const showPendingMessage = () => {
    if (logComponent('OrgRejectionPanel')) { console.debug('OrgRejectionPanel showPendingMessage'); }
    setCurrentDisplay('pending');
    setRejectionStart(Date.now());
  }

  const showResolvedMessage = (result) => {
    if (logComponent('OrgRejectionPanel')) { console.debug('OrgRejectionPanel showResolvedMessage'); }
    setCurrentDisplay(result);
    setRejectionStart(null);
    setResolutionTimeout(null);

    if (result === 'success') {
      setDelayedDismissal();
    }
  }

  const handleResolution = (result) => {
    if (logComponent('OrgRejectionPanel')) { console.debug('OrgRejectionPanel handleResolution'); }
    const elapsedTime = Date.now() - rejectionStart;

    if (elapsedTime > 1500) {
      showResolvedMessage(result);
    } else {
      setDelayedResolution(result, 1500 - elapsedTime);
    }
  }

  const setDelayedDismissal = () => {
    if (logComponent('OrgRejectionPanel')) { console.debug('OrgRejectionPanel setDelayedDismissal'); }
    setDismissalTimeout(setTimeout(() => {
      dismissParent();
    }, 1500));
  }

  const setDelayedResolution = (result, delay) => {
    if (logComponent('OrgRejectionPanel')) { console.debug('OrgRejectionPanel setDelayedResolution'); }

    setResolutionTimeout(setTimeout(() => {
      showResolvedMessage(result);
    }, delay));
  }

  const refresh = () => {
    if (logComponent('OrgRejectionPanel')) { console.debug('OrgRejectionPanel refresh'); }
    setRejectionStart(null);
    setCurrentDisplay('initial');
    setDismissalTimeout(null);
    setResolutionTimeout(null);
  }

  const updateRejectionReason = (e) => {
    if (logComponent('OrgRejectionPanel')) { console.debug('OrgRejectionPanel updateRejectionReason'); }
    setRejectionReason(e.target.value);
  }

  return (
    <div className="Org-Rejection-Panel">
      <textarea
        className="Org-Rejection-Panel__reason"
        disabled={currentDisplay !== 'initial'}
        onChange={updateRejectionReason}
        value={rejectionReason}
        placeholder="Please enter a reason for rejection"></textarea>
      {
        currentDisplay === 'initial' &&
        <div className="Org-Rejection-Panel__buttons">
          <button
            className="Org-Rejection-Panel__reject"
            onClick={confirmRejection}>Confirm Rejection</button>
          <button
            className="Org-Rejection-Panel__cancel"
            onClick={dismiss}>Cancel Rejection</button>
        </div>
      }
      {
        currentDisplay !== 'initial' &&
        <div className="Org-Rejection-Panel__message">
          {
            currentDisplay === 'pending' &&
            <p className="Org-Rejection-Panel__pending">Processing rejection...</p>
          }
          {
            currentDisplay === 'success' &&
            <p className="Org-Rejection-Panel__success">Organization successfully rejected!</p>
          }
          {
            currentDisplay === 'failure' &&
            <button
              className="Org-Rejection-Panel__failure"
              onClick={refresh}>Failed to process rejection. Click to try again.</button>

          }
        </div>
      }
    </div>
  );
}